import React from 'react';
import { Typography } from 'antd';

const IntervalDescription = ({ interval, targetDate }) => {
  if (!interval && !targetDate) {
    return null;
  }

  return (
    <Typography.Paragraph style={{ marginBottom: 0 }}>
      <Typography.Text>Запись на </Typography.Text>
      <Typography.Text strong>{targetDate}</Typography.Text>
      <Typography.Text> с </Typography.Text>
      <Typography.Text strong>{interval?.fromTime}</Typography.Text>
      <Typography.Text> до </Typography.Text>
      <Typography.Text strong>{interval?.toTime}</Typography.Text>
    </Typography.Paragraph>
  );
};

export default IntervalDescription;
